module.exports = __webpack_public_path__ + "img/screenshot_board.0c143ca2.png";